<div class="mat-mdc-select-arrow-wrapper">
  <div class="mat-mdc-select-arrow">
    <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false">
      <path d="M7 10l5 5 5-5z" />
    </svg>
  </div>
</div>
<!-- This only exists so that Angular includes the mat-select styles when this module is built -->
<mat-select class="mc-hidden"></mat-select>